import { render, staticRenderFns } from "./StatisticBar.vue?vue&type=template&id=e271b56c&scoped=true&"
import script from "./StatisticBar.vue?vue&type=script&lang=ts&"
export * from "./StatisticBar.vue?vue&type=script&lang=ts&"
import style0 from "./StatisticBar.vue?vue&type=style&index=0&id=e271b56c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e271b56c",
  null
  
)

export default component.exports